<!-- Footer Buttons -->
<tyl-button image="save black.png" label="Save" (clickEvent)="saveButtonEvent.emit(true)" *ngIf="saveEnabled"></tyl-button>
<tyl-button image="save disabled.png" label="Save" *ngIf="!saveEnabled" textColor="Grey"></tyl-button>
<ng-container *ngIf="!startOver">
	<tyl-button *ngIf="cancelEnabled" image="Cancel.png" label="Cancel" (clickEvent)="saveButtonEvent.emit(false)"></tyl-button>
	<tyl-button *ngIf="!cancelEnabled" image="Cancel disabled.png" label="Cancel" textColor="Grey"></tyl-button>
</ng-container>
<ng-container *ngIf="startOver">
	<tyl-button *ngIf="cancelEnabled" image="startover.png" label="Start Over" (clickEvent)="saveButtonEvent.emit(false)"></tyl-button>
	<tyl-button *ngIf="!cancelEnabled" image="startover disabled.png" label="Start Over" textColor="Grey"></tyl-button>
</ng-container>